export default "__VITE_ASSET__DKLGdivx__"